import { React, useContext } from "react";
import { PageContext } from "../../App";
import QRCodeType from "./QRCodeType";

function QRCodeInputView() {
  //get values
  const { qrCodeInputValue, setQRCodeInputValue } = useContext(PageContext);
  return (
    <div className="container mt-5 text-center">
      {/* Input field */}
      <input
        className="form-control text-center border-1 border-secondary fs-5 px-2"
        style={{ height: "60px" }}
        value={qrCodeInputValue.value}
        placeholder="Enter string to generate QR Code or Barcode for"
        onChange={(e) => {
          //set
          setQRCodeInputValue({ ...qrCodeInputValue, value: e.target.value });
        }}
      />

      {/* Type */}
      <div className="d-flex mt-4 my-auto text-center">
        {/* Label */}
        <label className="fs-6 me-2 text-secondary fs-3 my-auto">Type:</label>
        {/* Dropdown menu */}
        <div className="dropdown">
          <label
            className="dropdown-toggle fs-3 text-primary"
            type="text"
            id="dropdownMenu"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              //toggle
              setQRCodeInputValue({
                ...qrCodeInputValue,
                popupShowing:
                  qrCodeInputValue.popupShowing === true ? false : true,
              });
            }}
          >
            {qrCodeInputValue.type}
          </label>
          <div
            className={`dropdown-menu ${
              qrCodeInputValue.popupShowing === true ? "show" : ""
            }`}
            aria-labelledby="dropdownMenu"
          >
            <button
              className="dropdown-item"
              type="button"
              onClick={(e) => {
                //set configuration
                setQRCodeInputValue({
                  ...qrCodeInputValue,
                  popupShowing: false,
                  type: QRCodeType.BARCODE,
                });
              }}
            >
              {QRCodeType.BARCODE}
            </button>
            <button
              className="dropdown-item"
              type="button"
              onClick={(e) => {
                //set configuration
                setQRCodeInputValue({
                  ...qrCodeInputValue,
                  popupShowing: false,
                  type: QRCodeType.QR_CODE,
                });
              }}
            >
              {QRCodeType.QR_CODE}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QRCodeInputView;
